
class PaymentSource {
    constructor(API) {
        this.API = API;
    }

     async list() {
         return await this.API.get('/index.php?route=api/payment/methods')
     }

    async setMethod(data) {
        return await this.API.post("/index.php?route=api/payment/method", data)
    }

    async deleteCard(cardId) {
        return await this.API.post("/index.php?route=api/payment/deleteCard", { card_id: cardId })
    }
}

export default PaymentSource
